import { createTheme } from '@material-ui/core';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#f55d21',
    },
    secondary: {
      main: '#1e6ace',
    },
  },
  brand: {
    primary: '#f55d21',
    secondary: '#1e6ace',
    muted: '#C6DAF7',
  },
  ui: {
    primary: '#f55d21',
    secondary: '#1e6ace',
    tertiary: '#FEF0EA',
    quaternary: '#FFFFFF',
    disabled: '#DEDEDE',
    error: '#B00020',
    success: '#138000',
  },
  bg: {
    primary: '#FFFFFF',
    secondary: '#e2e2e2',
    tertiary: '#060b2f',
  },
  text: {
    primary: '#121212',
    secondary: '#757575',
    tertiary: '#060b2f',
    disabled: '#9C9C9C',
    inverse: '#FFFFFF',
    error: '#B00020',
    success: '#138000',
    item: '#8d766d',
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});
